import { useEffect } from 'react';
import { useAppDispatch } from '@/redux/store';
import { GeneralSlice } from '@/redux/general';
import UrlQuery from '@/utils/url-query';

const QID_URL_PARAMS = [
  'gclid',
  'ttclid',
  'fbclid',
  'pixel_id',
  'pixelid',
  'msclkid',
  'conv',
  'bid',
  'utm_pviews',
  'utm_sduration',
  'utm_creative',
  'utm_term',
  'utm_source',
  'utm_medium',
  'utm_content',
  'utm_campaign',
  'utm_campaignid',
  'utm_gclid',
  'utm_account',
  'utm_ad_type',
  'optimizely',
  'optimizelyVisitorId',
  'convertVisitorId',
];

const useStoreQidData = () => {
  const dispatch = useAppDispatch();

  const gatherQidDataFromUrlParams = (): Record<string, string> => {
    return QID_URL_PARAMS.reduce((qid, key) => ({ ...qid, [key]: UrlQuery.get(key).string() }), {});
  };

  useEffect(() => {
    dispatch(GeneralSlice.actions.setQid(gatherQidDataFromUrlParams()));
  }, []);
};

export default useStoreQidData;
